<script setup lang="ts">
import XBackTop from '@/components/XBackTop.vue'
function isIOS() {
	const userAgent = window.navigator.userAgent
	return /(iPhone|iPod|iPad)/.test(userAgent)
}
window.isIOS = isIOS()

console.log('---环境变量----', import.meta.env)
console.log('---isIos----', window.isIOS)
</script>

<template>
	<div class="wrap-app">
		<router-view />
		<XBackTop />
	</div>
</template>

<style>
.pdf-zoom-wrapper {
  touch-action: none;
}
</style>
